import React, { useMemo } from "react";
import {
  CheckboxGrid,
  CheckboxGridOp,
  CheckboxGridRe,
  CheckboxItem,
  CheckboxItemOp,
} from "./styled";

export const Checkboxes = ({
  options,
  data,
  setData,
  op = false,
  re = false,
}) => {
  const handleChange = (value) => {
    const currentSkills = data.skills || [];
    const newSkills = currentSkills.includes(value)
      ? currentSkills.filter((skill) => skill !== value)
      : [...currentSkills, value];

    setData({ ...data, skills: newSkills });
  };

  const sortedOptions = useMemo(() => {
    return [...options].sort((a, b) =>
      a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" })
    );
  }, [options]);

  return (
    <>
      {op ? (
        <CheckboxGridOp>
          {sortedOptions.map((option, index) => (
            <CheckboxItemOp key={index}>
              <input
                type="checkbox"
                value={option.name}
                checked={data.skills?.includes(option.name)}
                onChange={() => handleChange(option.name)}
              />
              {option.name}
            </CheckboxItemOp>
          ))}
        </CheckboxGridOp>
      ) : re ? (
        <CheckboxGridRe>
          {sortedOptions.map((option, index) => (
            <CheckboxItemOp key={index}>
              <input
                type="checkbox"
                value={option.name}
                checked={data.skills?.includes(option.name)}
                onChange={() => handleChange(option.name)}
              />
              {option.name}
            </CheckboxItemOp>
          ))}
        </CheckboxGridRe>
      ) : (
        <CheckboxGrid>
          {sortedOptions.map((option, index) => (
            <CheckboxItem key={index}>
              <input
                type="checkbox"
                value={option.name}
                checked={data.skills?.includes(option.name)}
                onChange={() => handleChange(option.name)}
              />
              {option.name}
            </CheckboxItem>
          ))}
        </CheckboxGrid>
      )}
    </>
  );
};
